export default __webpack_public_path__ + "static/media/Timer.13ad5531.svg";